// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonTabSmall = 32;
var ButtonTabMedium = 40;
var ButtonTabLarge = 48;
var ButtonSmall = 32;
var ButtonMedium = 40;
var ButtonLarge = 48;
var ControlCheckboxLarge = 18;
var ControlCheckboxSmall = 16;
var ControlRadioLarge = 18;
var ControlRadioSmall = 16;
var ControlSwitchLarge = 24;
var ControlSwitchSmall = 20;
var DatePickerDateCellSmall = 32;
var DatePickerDateCellMedium = 40;
var DatePickerDateCellLarge = 48;
var FieldSmall = 32;
var FieldMedium = 40;
var FieldLarge = 48;
var TagXSmall = 14;
var TagSmall = 20;
var TagMedium = 24;
var TagLarge = 32;
var SizeSemanticsAll = {
  ButtonLarge: ButtonLarge,
  ButtonMedium: ButtonMedium,
  ButtonSmall: ButtonSmall,
  ButtonTabLarge: ButtonTabLarge,
  ButtonTabMedium: ButtonTabMedium,
  ButtonTabSmall: ButtonTabSmall,
  ControlCheckboxLarge: ControlCheckboxLarge,
  ControlCheckboxSmall: ControlCheckboxSmall,
  ControlRadioLarge: ControlRadioLarge,
  ControlRadioSmall: ControlRadioSmall,
  ControlSwitchLarge: ControlSwitchLarge,
  ControlSwitchSmall: ControlSwitchSmall,
  DatePickerDateCellLarge: DatePickerDateCellLarge,
  DatePickerDateCellMedium: DatePickerDateCellMedium,
  DatePickerDateCellSmall: DatePickerDateCellSmall,
  FieldLarge: FieldLarge,
  FieldMedium: FieldMedium,
  FieldSmall: FieldSmall,
  TagLarge: TagLarge,
  TagMedium: TagMedium,
  TagSmall: TagSmall,
  TagXSmall: TagXSmall
};

export { ButtonLarge, ButtonMedium, ButtonSmall, ButtonTabLarge, ButtonTabMedium, ButtonTabSmall, ControlCheckboxLarge, ControlCheckboxSmall, ControlRadioLarge, ControlRadioSmall, ControlSwitchLarge, ControlSwitchSmall, DatePickerDateCellLarge, DatePickerDateCellMedium, DatePickerDateCellSmall, FieldLarge, FieldMedium, FieldSmall, SizeSemanticsAll, TagLarge, TagMedium, TagSmall, TagXSmall, SizeSemanticsAll as default };
